import { Fragment } from 'react';
import PropTypes from 'prop-types';
import connectWithExperiments from '../../decorators/connectWithExperiments';
import isServer from '../../utils/isServer';
import { ONETRUST_ENABLED } from '../../constants/experiments/ads';
import { OneTrust } from './OneTrust';

// exported for testing
export function ConsentManager({ [ONETRUST_ENABLED]: isOneTrustEnabled }) {
  if (isServer()) {
    return null;
  }

  return <Fragment>{isOneTrustEnabled && <OneTrust />}</Fragment>;
}

ConsentManager.propTypes = {
  [ONETRUST_ENABLED]: PropTypes.bool.isRequired,
};

export default connectWithExperiments([ONETRUST_ENABLED])(ConsentManager);
